'use client';

import * as React from 'react';

import { Description } from './description';

interface ListingDescriptionSectionProps {
  description: string;
}

export const ListingDescriptionSection: React.FC<
  ListingDescriptionSectionProps
> = ({ description }) => {
  return <Description description={description} />;
};
